import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  section: {
    marginTop: "x1cl2iem",
    $$css: true
  },
  header: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    marginBottom: "xyi6m4r",
    $$css: true
  },
  headerIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  headerTitle: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "xngnso2",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    $$css: true
  },
  list: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  card: {
    backgroundColor: "x1xaky2g",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x2rc37l",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  },
  avatars: {
    display: "x78zum5",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    overflowX: "xw2csxc",
    padding: "x79iv2k",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    scrollbarWidth: "x1rohswg",
    "::-webkit-scrollbar_display": "xfk6m8",
    $$css: true
  },
  body: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "xb6y1gh",
    rowGap: null,
    columnGap: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingTop: "x1iul6r4",
    paddingBottom: "x1uqvvkn",
    $$css: true
  },
  title: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1c3i2sq",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    textOverflow: "xlyipyv",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  pills: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    alignItems: "x6s0dn4",
    $$css: true
  },
  pill: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x7gbtqy",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    lineHeight: "xo5v014",
    $$css: true
  },
  pillPublic: {
    backgroundColor: "x19tgrng",
    color: "x18yk8ih",
    $$css: true
  },
  pillFriends: {
    backgroundColor: "xdxnv2l",
    color: "x3gwbum",
    $$css: true
  },
  pillInvite: {
    backgroundColor: "xz68oki",
    color: "x1gkxerh",
    $$css: true
  },
  pillGender: {
    backgroundColor: "x1gvq2gg",
    color: "xarw3lm",
    $$css: true
  },
  pillAge: {
    backgroundColor: "x15xno7f",
    color: "xtt1gjl",
    paddingInline: "x1ryrjj2",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  ageIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  progress: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  progressIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  track: {
    flex: "x98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    height: "x164u9eo",
    borderRadius: "x6i6fhv",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x4aap8p",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  },
  fill: {
    height: "x5yr21d",
    borderRadius: "x6i6fhv",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xwk94rn",
    $$css: true
  },
  fillFull: {
    backgroundColor: "x1yi5t32",
    $$css: true
  }
};